










































































































import eventTracker from '@/utils/eventTracker'
import NavDropdown from '@components/NavDropdown.vue'
import WrappedLink from '@components/WrappedLink.vue'
import SearchBar from '@components/SearchBar.vue'
import Settings from '@components/modals/Settings.vue'
import overlays from '@/mixins/overlays'
import wrappers from '@/mixins/wrappers'
import mixins from 'vue-typed-mixins'
import { Location } from 'vue-router'
import { Category } from '@/types/content'
import { TrialTime, AcceptedAgreements } from '@/types/user'

export default mixins(overlays, wrappers).extend({
  name: 'NavBar',
  props: {
    light: {
      type: Boolean,
      default: false
    }
  },
  components: {
    NavDropdown,
    SearchBar,
    WrappedLink
  },
  data () {
    return {
      q: ''
    }
  },
  computed: {
    categories (): Array<Category> {
      return this.$store.getters['user/content/categories']
    },
    trialTime (): TrialTime {
      return this.$store.getters['user/trialTime']
    },
    reportURL (): string {
      return this.$store.getters['user/reportURL']
    }
  },
  methods: {
    listItemClicked () {
      this.$store.dispatch('user/content/SetSearchBarVisibility', false)
    },
    async updateSearch (value: string) {
      eventTracker.track('LearnSearch triggered', { searchTerm: value })
      await this.navigate({ name: 'Learning:Search', query: { q: value } })
    },
    openSearchBar (event: InputEvent) {
      const target = event.currentTarget as HTMLButtonElement
      if (target) {
        target.blur()
      }
      this.q = ''
      this.$store.dispatch('user/content/SetSearchBarVisibility', true)
      eventTracker.track('Learn Search', {})
    },
    async openSettings (event: InputEvent) {
      const target = event.currentTarget as HTMLButtonElement
      if (target) {
        target.blur()
      }
      const { firstName, lastName } = this.$store.getters['user/me']
      const name = `${firstName} ${lastName}`.trim()
      const trialStart = this.trialTime.start['MMMM D, YYYY']
      const trialEnd = this.trialTime.end['MMMM D, YYYY']
      const { action, data } = await this.showModal({
        component: Settings,
        events: ['done', 'navigate'],
        props: {
          name,
          trialStart,
          trialEnd
        }
      })
      if (action === 'navigate') {
        await this.navigate(data)
      }
    },
    async closeSearchBar ({ name, query }: Location) {
      this.$store.dispatch('user/content/SetSearchBarVisibility', false)
      await this.navigate({ name, query })
    },
    reportDownloadRequested (event: MouseEvent) {
      const target = event.currentTarget as HTMLButtonElement
      if (target) {
        target.blur()
      }
      if (this.trialTime.is().trialStarted) {
        eventTracker.track('mySCSReportViewed', {})
      }
      else {
        event.preventDefault()
        this.showModal(
          this.$t('userMessages.noReport.message'),
          {
            title: this.$t('userMessages.noReport.title'),
            buttonLabel: this.$t('actions.dismiss')
          }
        )
      }
    },
    async goHome (event: InputEvent) {
      const target = event.currentTarget as HTMLButtonElement
      if (target) {
        target.blur()
      }
      const acceptedAgreements: AcceptedAgreements = this.$store.getters['user/byKey']('acceptedAgreements')
      if (!acceptedAgreements.includes('tos')) {
        await this.navigate({ name: 'Onboarding:Slides' })
      }
      else if (!acceptedAgreements.includes('privacy')) {
        await this.navigate({
          name: 'Onboarding:Agreements',
          query: { from: 'privacy' }
        })
      }
      else {
        await this.navigate({ name: 'Track' })
      }
    }
  }
})
